<template>
  <div class="form-group">
    <label class="form-label">Событие</label>
    <span class="subtitle">Расторжение трудового договора по причине (отметить из списка):</span>
    
    <CustomSelect name="event" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option value="Downsizing">Сокращение численности штата</option>
      <option value="OrganizationLiquidation">Ликвидация организации</option>
      <option value="OwnershipChange">Смена собственника имущества организации</option>
      <option value="EmployeeRecovery">Восстановление работника, ранее выполнявшего работу</option>
      <option value="RefusalToTransfer">Отказ работника от перевода на работу в другую местность</option>
      <option value="ByAgreement">По соглашению сторон</option>
      <option value="Other">Другое</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoApplicant/>
</template>

<script>
import ContractInfoApplicant from "@/components/insurances/shared/ContractInfoApplicant";
import * as mns from "@/store/mutation-types";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "JobLossInsurance",
  components: {ContractInfoApplicant, CustomSelect},
  methods: {
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_EVENT, event.getValue().value);
    },
    onEventSelectItemSelected(event){
      this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
    },
  },
  computed: {
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>
  .subtitle{
    display: block;
    font-size: .8rem;
    color: #9e9e9e;
  }
</style>